import { AuthState } from "@aws-amplify/ui-components";
import { Link, Redirect } from "react-router-dom";
import { Button } from "@mui/material";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import { ALUMNI, EVENTS, FEED, JOBS } from "../../constants/routes";
import { useAuth } from "../../hooks/useAuth";
import zoomImage from "../../assets/zoom.jpg";
import "./home.scss";

const isFeedLive = false;
const Home = () => {
  const auth = useAuth();

  return isFeedLive && auth.authState === AuthState.SignedIn && auth.user ? (
    <Redirect to={FEED} />
  ) : (
    <div className="home">
      <h1 className="title">
        Connect with <br />
        Code Platoon Alumni
      </h1>
      <div className="section">
        <div className="image-div">
          <img className="image" alt="zoom on laptop" src={zoomImage} />
        </div>
        <div className="buttons">
          <Button
            disabled
            className="button"
            fullWidth
            variant="outlined"
            size="large"
            endIcon={<ArrowForwardIosRoundedIcon />}
            component={Link}
            to={EVENTS}
          >
            Attend an event
          </Button>
          <Button
            className="button"
            fullWidth
            variant="outlined"
            size="large"
            endIcon={<ArrowForwardIosRoundedIcon />}
            component={Link}
            to={ALUMNI}
          >
            Search alumni
          </Button>
          <Button
            disabled
            className="button"
            fullWidth
            variant="outlined"
            size="large"
            endIcon={<ArrowForwardIosRoundedIcon />}
            component={Link}
            to={JOBS}
          >
            Find job openings
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Home;
